var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketballPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.16 7.20584C24.023 6.33373 25.4301 6.32623 26.3022 7.18955L28.8828 9.74353L32.3032 18.201L30.6294 17.4981C30.3674 17.388 30.1289 17.2286 29.9268 17.0287L23.1763 10.3481C22.3041 9.48478 22.2969 8.07795 23.16 7.20584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5021 6.71578C33.6367 6.24656 34.9355 6.78562 35.4046 7.91941L38.6252 15.7038L46.1005 16.4858C47.6125 16.6439 48.7605 17.9182 48.7611 19.4384L48.7656 35.898L47.3831 45.4383L51.1996 56.5355C51.669 57.9006 50.9429 59.3879 49.5778 59.8574C48.213 60.327 46.7255 59.6009 46.2559 58.2357L42.2333 46.5391C42.098 46.1453 42.0585 45.7247 42.1186 45.3124L43.3254 37.0235H40.6837L39.5318 44.9358C39.4118 45.7602 39.4907 46.6014 39.7616 47.3892L43.7842 59.0858C43.888 59.3875 44.0174 59.6728 44.1676 59.9418C43.9883 59.9796 43.8084 60.0003 43.6304 60.0003C42.5454 60.0003 41.5314 59.3194 41.1587 58.2359L37.1361 46.5393C37.0008 46.1454 36.9613 45.7248 37.0214 45.3125C38.5796 34.6091 38.4668 35.3352 38.5203 35.1267V21.9888L44.874 20.7088L36.8953 20.0137C36.0692 19.9417 35.3521 19.4159 35.0351 18.6497L31.2985 9.61828C30.8293 8.48437 31.3682 7.18488 32.5021 6.71578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.487 9.21605C38.893 7.12918 40.7298 5.55371 42.9354 5.55371C45.4387 5.55371 47.4682 7.58316 47.4682 10.0865C47.4682 12.5899 45.4387 14.6192 42.9354 14.6192C40.1003 14.6191 37.9385 12.0346 38.487 9.21605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8891 8.46281C10.5521 8.46281 8.65767 6.56835 8.65767 4.23141C8.65767 1.89447 10.5521 0 12.8891 0C15.226 0 17.1205 1.89447 17.1205 4.23141C17.1205 6.56835 15.226 8.46281 12.8891 8.46281Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballPlayer);
export default __webpack_public_path__ + "static/media/basketball-player.ccd46326ea2391eb569c92ff30784f83.svg";
export { ForwardRef as ReactComponent };